/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIAutocompleteSuggestion } from './APIAutocompleteSuggestion';
import {
    APIAutocompleteSuggestionFromJSON,
    APIAutocompleteSuggestionFromJSONTyped,
    APIAutocompleteSuggestionToJSON,
} from './APIAutocompleteSuggestion';

/**
 * Standard autocomplete response with total count.
 * @export
 * @interface APINamedAutocompleteResponse
 */
export interface APINamedAutocompleteResponse {
    /**
     * 
     * @type {Array<APIAutocompleteSuggestion>}
     * @memberof APINamedAutocompleteResponse
     */
    suggestions: Array<APIAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APINamedAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APINamedAutocompleteResponse interface.
 */
export function instanceOfAPINamedAutocompleteResponse(value: object): value is APINamedAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APINamedAutocompleteResponseFromJSON(json: any): APINamedAutocompleteResponse {
    return APINamedAutocompleteResponseFromJSONTyped(json, false);
}

export function APINamedAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APINamedAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APINamedAutocompleteResponseToJSON(value?: APINamedAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

